import { WithLayoutType } from '@sbercloud/uikit-product-utils';

import { BlogRichText } from '../BlogRichText';
import { Title } from '../Title';
import styles from './styles.module.scss';

type TextBlockProps = WithLayoutType<{
  id?: string;
  title?: string;
  richText?: string;
}>;

export function TextBlock(props: TextBlockProps) {
  const { id, layoutType, title, richText } = props;

  if (!title && !richText) {
    return null;
  }

  return (
    <div className={styles.textBlock} data-test-id="text-block">
      {title ? <Title id={id} layoutType={layoutType} title={title} /> : null}
      {richText ? (
        <BlogRichText layoutType={layoutType} richText={richText} />
      ) : null}
    </div>
  );
}
